module.exports = __webpack_public_path__ + "static/media/web-1.681f173a.jpg";